import { AdditionServicesOptionsState } from '@pages/AdditionalServices/containers/additionServicesOptionsContext';
import {
  AServiceCache,
  AServicePropertyCache,
  AServicePropertyFilterAndOrder,
  AdditionServicesState,
} from '@pages/AdditionalServices/containers/types';

import { ServiceData, SetUpServiceData } from '../../../basket/types';
import { calculateFieldValues } from '../../../calculateFieldValues';
import { serviceRestoreStateGeneratorProcessor } from '../types';

/**
 * SetUpVariantFieldsProcessor формирует и восстанавливает значения полей вариантов на основе установочной услуги.
 * Устанавлиает восстановленное значение только если оно не скрыто и не пренадлежит к ограничениям.
 */
export class SetUpVariantFieldsProcessor implements serviceRestoreStateGeneratorProcessor {
  /**
   * restore выполняет восстановление стейтов. Возвращает все стейты.
   * @param setUpServiceData
   * @param __
   * @param additionalServiceState
   * @param optionsState
   * @param serviceCacheState
   * @param servicePropertyCacheState
   * @param servicePropertyFilterAndOrderState
   */
  async restore(
    setUpServiceData: SetUpServiceData,
    __: (SetUpServiceData | ServiceData)[],
    additionalServiceState: AdditionServicesState,
    optionsState: AdditionServicesOptionsState,
    serviceCacheState: AServiceCache,
    servicePropertyCacheState: AServicePropertyCache,
    servicePropertyFilterAndOrderState: AServicePropertyFilterAndOrder
  ) {
    const variantFieldValues: {
      [x: string]: number;
    } = Object.values(additionalServiceState.VariantFieldValues).reduce(
      (prev, item) => ({
        ...prev,
        ...item,
      }),
      {}
    );

    const setUpFieldValues: { [T in string]: number } = {};
    const setUpFieldList = Object.values(additionalServiceState.VariantFields)
      .flat(1)
      .map((field) => {
        const setUpValue = setUpServiceData.VariantFieldValues[field.code];
        const currentValue = variantFieldValues[field.code];

        if (
          field.type === 'hidden' ||
          field.settings.DefaultSettings.IsNeedDisplayOnlyTextInfo
        ) {
          setUpFieldValues[field.code] = currentValue;
          return { ...field, value: currentValue };
        }

        if (
          !!setUpValue &&
          field.handbook_limitations.length > 0 &&
          !field.handbook_limitations.includes(setUpValue.toString())
        ) {
          setUpFieldValues[field.code] = currentValue;
          return { ...field, value: currentValue };
        }
        setUpFieldValues[field.code] = setUpValue ?? currentValue;
        return { ...field, value: setUpValue ?? currentValue };
      });

    const calculatedFieldValues = calculateFieldValues(setUpFieldList, setUpFieldValues, {});

    const values: { [T in string]: { [T in string]: number } } = {};

    Object.entries(additionalServiceState.VariantFields).forEach(([key, value]) => {
      if (value.length === 0) {
        values[key] = {};
        return;
      }

      value.forEach((field) => {
        if (values[key]) {
          values[key][field.code] = calculatedFieldValues[field.code];
          return;
        }

        values[key] = { [field.code]: calculatedFieldValues[field.code] };
      });
    });

    return {
      isValid: true,
      additionalServiceState: {
        ...additionalServiceState,
        VariantFieldValues: values,
      },
      optionsState,
      serviceCacheState,
      servicePropertyCacheState,
      servicePropertyFilterAndOrderState,
    };
  }
}
